import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import livestreamService from '../../services/livesession/LivestreamService';
import { t } from '../../services/i18nService';

import styles from './header.scss';

class LivestreamStatus extends React.PureComponent {
    render() {
        const { isLivestreaming } = this.props;

        if (isLivestreaming) {
            return (
                <span className={styles.inlineSubHeaderText}>
                    <i className="fa fa-video-camera" aria-hidden />
                    &nbsp;&nbsp;{t('livestream.started')}
                </span>
            );
        }
        return (
            <span className={styles.inlineSubHeaderText}>
                <i className="fa fa-pause" aria-hidden />
                &nbsp;&nbsp;{t('livestream.notStarted')}
            </span>
        );
    }
}

LivestreamStatus.propTypes = {
    isLivestreaming: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isLivestreaming: livestreamService.isCompleted(state.livestream),
    };
};

export default connect(mapStateToProps)(LivestreamStatus);
